/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import moment from 'moment';
import { DayOffWeek } from '../interfaces';
// @ts-ignore
import 'moment/locale/pt-br';

export const DaysOfWeek: Array<DayOffWeek> = [
  {
    idDiaDaSemana: 1, label: 'Segunda-Feira', check: false, hours: [],
  },
  {
    idDiaDaSemana: 2, label: 'Terça-Feira', check: false, hours: [],
  },
  {
    idDiaDaSemana: 3, label: 'Quarta-Feira', check: false, hours: [],
  },
  {
    idDiaDaSemana: 4, label: 'Quinta-Feira', check: false, hours: [],
  },
  {
    idDiaDaSemana: 5, label: 'Sexta-Feira', check: false, hours: [],
  },
  {
    idDiaDaSemana: 6, label: 'Sábado', check: false, hours: [],
  },
  {
    idDiaDaSemana: 0, label: 'Domingo', check: false, hours: [],
  },
];

export const calendar = [
  {
    dia: moment().day(1).format('dddd').substring(0, 3)
      .toUpperCase(),
    data: moment().day(1).format('DD/MM'),
    dataSet: '2021-11-01',
    fullData: moment().day(1).locale('pt-br').format('LL'),
  },
  {
    dia: moment().day(2).format('dddd').substring(0, 3)
      .toUpperCase(),
    data: moment().day(2).format('DD/MM'),
    dataSet: '2021-11-02',
    fullData: moment().day(2).locale('pt-br').format('LL'),
  },
  {
    dia: moment().day(3).format('dddd').substring(0, 3)
      .toUpperCase(),
    data: moment().day(3).format('DD/MM'),
    dataSet: '2021-11-03',
    fullData: moment().day(3).locale('pt-br').format('LL'),
  },
  {
    dia: moment().day(4).format('dddd').substring(0, 3)
      .toUpperCase(),
    data: moment().day(4).format('DD/MM'),
    dataSet: '2021-11-04',
    fullData: moment().day(4).locale('pt-br').format('LL'),
  },
  {
    dia: moment().day(5).format('dddd').substring(0, 3)
      .toUpperCase(),
    data: moment().day(5).format('DD/MM'),
    dataSet: '2021-11-05',
    fullData: moment().day(5).locale('pt-br').format('LL'),
  },
  {
    dia: moment().day(6).format('dddd').substring(0, 3)
      .toUpperCase(),
    data: moment().day(6).format('DD/MM'),
    dataSet: '2021-11-06',
    fullData: moment().day(6).locale('pt-br').format('LL'),
  },
  {
    dia: moment().day(7).format('dddd').substring(0, 3)
      .toUpperCase(),
    data: moment().day(7).format('DD/MM'),
    dataSet: '2021-11-07',
    fullData: moment().day(7).locale('pt-br').format('LL'),
  },
];

export const nextCalendar = [
  {
    dia: moment().day('monday').weekday(1).add(7, 'day')
      .format('dddd')
      .substring(0, 3)
      .toUpperCase(),
    data: moment().day('monday').weekday(1).add(7, 'day')
      .format('DD/MM'),
    dataSet: moment().day('monday').weekday(1).add(7, 'day')
      .format('YYYY-MM-DD'),
    fullData: moment()
      .day('monday')
      .weekday(1)
      .add(7, 'day')
      .locale('pt-br')
      .format('LL'),
  },
  {
    dia: moment().day('tuesday').weekday(2).add(7, 'day')
      .format('dddd')
      .substring(0, 3)
      .toUpperCase(),
    data: moment().day('tuesday').weekday(2).add(7, 'day')
      .format('DD/MM'),
    dataSet: moment().day('tuesday').weekday(2).add(7, 'day')
      .format('YYYY-MM-DD'),
    fullData: moment().day('tuesday').weekday(2).add(7, 'day')
      .format('LL'),
  },
  {
    dia: moment().day('wednesday').weekday(3).add(7, 'day')
      .format('dddd')
      .substring(0, 3)
      .toUpperCase(),
    data: moment().day('wednesday').weekday(3).add(7, 'day')
      .format('DD/MM'),
    dataSet: moment().day('wednesday').weekday(3).add(7, 'day')
      .format('YYYY-MM-DD'),
    fullData: moment()
      .day('wednesday')
      .weekday(3)
      .add(7, 'day')
      .locale('pt-br')
      .format('LL'),
  },
  {
    dia: moment().day('thursday').weekday(4).add(7, 'day')
      .format('dddd')
      .substring(0, 3)
      .toUpperCase(),
    data: moment().day('thursday').weekday(4).add(7, 'day')
      .format('DD/MM'),
    dataSet: moment().day('thursday').weekday(4).add(7, 'day')
      .format('YYYY-MM-DD'),
    fullData: moment()
      .day('thursday')
      .weekday(4)
      .add(7, 'day')
      .locale('pt-br')
      .format('LL'),
  },
  {
    dia: moment().day('friday').weekday(5).add(7, 'day')
      .format('dddd')
      .substring(0, 3)
      .toUpperCase(),
    data: moment().day('friday').weekday(5).add(7, 'day')
      .format('DD/MM'),
    dataSet: moment().day('friday').weekday(5).add(7, 'day')
      .format('YYYY-MM-DD'),
    fullData: moment()
      .day('friday')
      .weekday(5)
      .add(7, 'day')
      .locale('pt-br')
      .format('LL'),
  },
  {
    dia: moment().day('saturday').weekday(6).add(7, 'day')
      .format('dddd')
      .substring(0, 3)
      .toUpperCase(),
    data: moment().day('saturday').weekday(6).add(7, 'day')
      .format('DD/MM'),
    dataSet: moment().day('saturday').weekday(6).add(7, 'day')
      .format('YYYY-MM-DD'),
    fullData: moment()
      .day('saturday')
      .weekday(6)
      .add(7, 'day')
      .locale('pt-br')
      .format('LL'),
  },
  {
    dia: moment().day('friday').weekday(7).add(7, 'day')
      .format('dddd')
      .substring(0, 3)
      .toUpperCase(),
    data: moment().day('friday').weekday(7).add(7, 'day')
      .format('DD/MM'),
    dataSet: moment().day('friday').weekday(7).add(7, 'day')
      .format('YYYY-MM-DD'),
    fullData: moment()
      .day('friday')
      .weekday(7)
      .add(7, 'day')
      .locale('pt-br')
      .format('LL'),
  },
];
